<template>
	<router-link class="app-logo" :to="{ name: 'SiteOverview' }">
		<span class="app-logo__text">银合Pilot 数字员工平台</span>
	</router-link>
</template>

<script>
export default {
	name: 'AppLogo'
};
</script>
